import { gql } from "@apollo/client";

export const QUERY_FORM3457F_VERSION = gql`
  query studentForm3457F(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3457F(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      parent1
      parent2
      consent
      receivedCopy
      receivedIepEligibilitySummary
      receivedEducationProgram
      receivedOther
      otherName
      parentSignatureDate
      acceptOptionToDelayService
      documentContactName
      documentContactTitle
      documentContactPhone
      signatureName
      signatureTitle
      signatureName
      signatureTitle
      formAction
      formStatus
    }
  }
`;
